import axios from "axios";

export default {
  namespaced: true,
  state: {
    items: [],
  },
  getters: {
    getItems(state) {
      return state.items;
    },
    getSelectedItems(state) {
      return state.items.map((server) => ({
        value: server.id,
        label: server.name,
        domain: server.domain,
      }));
    },
  },
  mutations: {
    setData(state, value) {
      state.items = value;
    },
  },
  actions: {
    async getAll({ commit }, params) {
      const { data } = await axios.get(`${window.__env.VUE_APP_PBX_URL}/v1/master-accounts`, {params});

      if (!data.status) {
        return [];
      }

      commit("setData", data.data);
      return data;
    },
    async add(_, params) {
      const { data } = await axios.post(`${window.__env.VUE_APP_PBX_URL}/v1/master-accounts`, params);

      return data;
    },
    async export({ commit }, params) {
      const { data } = await axios.get(`${window.__env.VUE_APP_PBX_URL}/v1/master-accounts`, {
        params: {
          ...params,
          export: true,
        },
        headers: {
          "Content-Disposition": "attachment; filename=template.xlsx",
          "Content-Type":
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        },
        responseType: "arraybuffer",
      });

      return data;
    },
    async edit(_, { id, params }) {
      const { data } = await axios.put(`${window.__env.VUE_APP_PBX_URL}/v1/master-accounts/${id}`, params);

      return data;
    },
    async delete(_, id) {
      const { data } = await axios.delete(`${window.__env.VUE_APP_PBX_URL}/v1/master-accounts/${id}`);

      return data;
    },

    clear({ commit }) {
      commit("setData", []);
    },
  },
};
